// @flow
import React, { useCallback, useState, useEffect, useContext } from 'react';
import classNames from 'classnames/bind';
import VisibilitySensor from 'react-visibility-sensor';

import Picture from 'app/common/ui-next/picture';
import { DotsLoader } from 'app/common/components/Loader';

import { places } from './places';
import BannersContext from './banners-context';
import styles from './banner.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  placeId: string,
  className?: string,
  skipRefresh?: boolean,
}

const Banner = ({ placeId, className, skipRefresh }: Props) => {
  const { width = '', height = '', description = '' } = places[placeId] || {};
  // для блокировки анимации при перезагрузке баннера
  const [alreadyLoaded, setAlreadyLoaded] = useState(false);
  // индикация загрузки файла, не всегда работает
  const [imageLoading, setImageLoading] = useState(true);
  const handleImageLoaded = useCallback(() => {
    setImageLoading(false);
  }, []);

  const {
    data: { getBannerDataByPlaceId },
    effects: {
      refreshBannerByPlaceId,
      pauseBannerByPlaceId,
    },
  } = useContext(BannersContext);

  const {
    loading: bannerLoading = false,
    bannerUrl = '',
    actionUrl = '',
  } = getBannerDataByPlaceId(placeId) || {};

  const loading = bannerLoading; // || imageLoading;

  useEffect(() => {
    if (!skipRefresh) {
      refreshBannerByPlaceId(placeId);
    }
    return () => {
      pauseBannerByPlaceId(placeId);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // после загрузки данных баннера
  useEffect(() => {
    if (!loading) {
      // localStorage.setItem(placeId, String(Date.now() + timing));
      if (!alreadyLoaded) {
        setAlreadyLoaded(true);
      }
    }
  }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleVisibility = useCallback(() => {
    // TODO visibility tracking
  }, []);

  const handleClick = useCallback(() => {
    // TODO click tracking
  }, []);

  const linkParams = {
    target: '_blank',
    rel: 'noopener noreferrer',
    href: actionUrl,
    onClick: handleClick,
    className: styles.link,
  };

  const pictureParams = {
    alt: description,
    src: bannerUrl,
    onImageLoaded: handleImageLoaded,
    className: styles.image,
    width,
    height,
  };

  const bannerClassName = cx(
    styles.root,
    bannerUrl ? className : null,
  );

  const style = {
    width,
    height: loading && !alreadyLoaded ? '' : height,
    overflow: loading && !alreadyLoaded ? 'hidden' : 'inherit',
  };

  if (!bannerUrl) {
    return null;
  }

  return (
    <VisibilitySensor onChange={handleVisibility} partialVisibility delayedCall>
      <div
        className={bannerClassName}
        style={style}
      >
        {actionUrl
          ? <a {...linkParams}><Picture {...pictureParams} /></a>
          : <Picture {...pictureParams} />}

        {imageLoading
          && <DotsLoader className={styles.loader} />}
      </div>
    </VisibilitySensor>
  );
};

export default Banner;
